import { Theme } from "@mui/material/styles";

export default function Radio(theme: Theme) {
    return {
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginRight: theme.spacing(4),
                },
                label: {
                    ...theme.typography.body2,
                },
            },
        },
    };
}
